<template>
  <div id="exportContent" class="general-style" v-if="pegawais">
    <div class="text-align-center font-size-13">
      <br />
      <br />
      <br />
      <br />
      KEPUTUSAN DIREKSI PERUSAHAAN UMUM DAERAH AIR MINUM <br />TIRTA HITA
      BULELENG<br />NOMOR: {{ noSurat.toUpperCase() }}
      <!-- 191 TAHUN 2024 -->
      <br />
      TENTANG <br />
      <div class="text-bold">
        {{ titleText.toUpperCase() }}
      </div>
      <br />
      DIREKSI PERUSAHAAN UMUM DAERAH AIR MINUM
      <br />
      TIRTA HITA BULELENG
      <br />
      <table class="table">
        <tr>
          <td>Menimbang</td>
          <td>:</td>
          <td colspan="2" v-if="jenisDokumen === 'kpReguler'">
            bahwa Pegawai Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng
            yang namanya tersebut dalam keputusan ini telah memenuhi syarat dan
            dipandang cakap untuk dinaikkan pangkatnya dalam pangkat setingkat
            lebih tinggi, dan perlu ditetapkan dengan Keputusan Direksi
            Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng.
          </td>

          <td colspan="2" v-if="jenisDokumen === 'kpPilihan'">
            bahwa untuk meningkatkan prestasi kerja dan gairah kerja bagi
            pejabat di lingkungan Perusahaan Umum Daerah Air Minum Tirta Hita
            Buleleng yang telah memenuhi syarat dan dipandang cakap, maka perlu
            memberikan kenaikan pangkat secara pilihan yang ditetapkan dengan
            Keputusan Direksi Perusahaan Umum Daerah Air Minum Tirta Hita
            Buleleng.
          </td>

          <td colspan="2" v-if="jenisDokumen === 'kgb'">
            bahwa Pegawai Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng
            yang namanya tersebut dalam keputusan ini, dipandang telah memenuhi
            syarat untuk diberikan Kenaikan Gaji Berkala dan perlu ditetapkan
            dengan Keputusan Direksi Perusahaan Umum Daerah Air Minum Tirta Hita
            Buleleng.
          </td>

          <td
            colspan="2"
            v-if="jenisDokumen === 'kpPenyesuaian'"
            class="text-align-left"
            style="padding-left: 0"
          >
            <ol
              class="custom-list"
              style="padding-left: 0; list-style-type: lower-alpha"
            >
              <li>
                bahwa berdasarkan Peraturan Perusahaan Tata Tertib Kerja
                2023-2025 Pasal 30 menyatakan Kenaikan Pangkat Penyesuaian
                diberikan kepada Pegawai yang memperoleh /memiliki ijasah lebih
                tinggi dari ijasah yang diakui pada saat pertama diangkat
                sebagai Pegawai dengan memenuhi ketentuan dan syarat-syarat;
              </li>
              <li>
                bahwa berdasarkan Keputusan Direksi Perusahaan Umum Daerah Air
                Minum Tirta Hita Buleleng Nomor 227 Tahun 2024 tentang Pengakuan
                Tanda Kelulusan / Ijasah;
              </li>
              <li>
                bahwa untuk dimaksud tersebut huruf a dan b diatas, perlu
                ditetapkan dengan Keputusan Direksi Perusahaan Umum Daerah Air
                Minum Tirta Hita Buleleng.
              </li>
            </ol>
          </td>

          <td
            colspan="2"
            v-if="jenisDokumen === 'persen80'"
            class="text-align-left"
            style="padding-left: 0"
          >
            <ol
              class="custom-list"
              style="padding-left: 0; list-style-type: lower-alpha"
            >
              <li>
                bahwa untuk melaksanakan ketentuan Pasal 64 Peraturan Daerah
                Nomor 04 Tahun 2020 tentang Perusahaan Umum Daerah Air Minum
                Tirta Hita Buleleng;
              </li>
              <li>
                bahwa berdasarkan ketentuan Pasal 20 Peraturan Perusahaan Tata
                Tertib Kerja 2023-2025 Perusahaan Umum Daerah Air Minum Tirta
                Hita Buleleng, Pengangkatan menjadi calon pegawai tetap
                dilaksanakan setelah memenuhi persyaratan diantaranya melalui
                tahapan sebagai calon pegawai tetap;
              </li>
              <li>
                bahwa berdasarkan pertimbangan sebagaimana dimaksud huruf a dan
                huruf b perlu ditetapkan dengan Surat Keputusan Direksi
                Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng.
              </li>
            </ol>
          </td>

          <td
            colspan="2"
            v-if="jenisDokumen === 'persen100'"
            class="text-align-left"
            style="padding-left: 0"
          >
            <ol
              class="custom-list"
              style="padding-left: 0; list-style-type: lower-alpha"
            >
              <li>
                bahwa untuk melaksanakan Peraturan Daerah Nomor 04 Tahun 2020
                tentang Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng
                Pasal 64 bagian Kelima Pegawai Perusahaan Umum Daerah Air Mi-num
                Tirta Hita Buleleng;
              </li>
              <li>
                b. bahwa berdasarkan ketentuan Pasal 19 Peraturan Tata Tertib
                Kerja 2023-2025 Perusahaan Umum Daerah Air Minum Tirta Hita
                Buleleng, Pengangkatan menjadi pegawai tetap dilaksanakan
                setelah memenuhi persyaratan diantaranya melalui tahapan sebagai
                calon pegawai tetap;
              </li>
              <li>
                c. bahwa berdasarkan pertimbangan sebagaimana dimaksud huruf a
                dan huruf b perlu ditetapkan dengan Surat Keputusan Direksi
                Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng.
              </li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>Mengingat</td>
          <td>:</td>
          <td colspan="2" class="text-align-left" style="padding-left: 0">
            <ol class="custom-list" style="padding-left: 0">
              <li>Undang-Undang Nomor 13 Tahun 2003;</li>
              <li>Undang-Undang Nomor 23 Tahun 2014;</li>
              <li>Peraturan Pemerintah Nomor 54 Tahun 2017;</li>
              <li>Permendagri Nomor 2 Tahun 2007;</li>
              <li>Permendagri Nomor 37 Tahun 2018;</li>
              <li>Peraturan Daerah Kabupaten Buleleng Nomor 4 Tahun 2020;</li>
              <li>Peraturan Bupati Buleleng Nomor 3 Tahun 2009;</li>
              <li>Peraturan Bupati Buleleng Nomor 48 Tahun 2013;</li>
              <li>
                Keputusan Kuasa Pemilik Modal No.09/Skep/KPM/THB/VIII/2021;
              </li>
              <li>
                Surat Keputusan Kepala Dinas Tenaga Kerja Kabupaten Buleleng
                Nomor 50 Tahun 2023 tentang Pengesahan Peraturan Tata Tertib
                Kerja 2023 - 2025 Perusahaan Umum Daerah Air Minum Tirta Hita
                Buleleng.
              </li>
            </ol>
          </td>
        </tr>

        <!-- <tr class="text-align-left">
          <td rowspan="10">Mengingat</td>
          <td rowspan="10">:</td>
          <td style="width: 3%" class="padding-bottom-0">1.</td>
          <td class="padding-bottom-0">Undang-Undang Nomor 13 Tahun 2003;</td>
        </tr>
        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">2.</td>
          <td class="padding-top-0">Undang-Undang Nomor 23 Tahun 2014;</td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">3.</td>
          <td class="padding-top-0">
            Peraturan Pemerintah Nomor 54 Tahun 2017;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">4.</td>
          <td class="padding-top-0">Permendagri Nomor 2 Tahun 2007;</td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">5.</td>
          <td class="padding-top-0">Permendagri Nomor 37 Tahun 2018;</td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">6.</td>
          <td class="padding-top-0">
            Peraturan Daerah Kabupaten Buleleng Nomor 4 Tahun 2020;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">7.</td>
          <td class="padding-top-0">
            Peraturan Bupati Buleleng Nomor 3 Tahun 2009;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">8.</td>
          <td class="padding-top-0">
            Peraturan Bupati Buleleng Nomor 48 Tahun 2013;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">9.</td>
          <td class="padding-top-0">
            Keputusan Kuasa Pemilik Modal No.09/Skep/KPM/THB/VIII/2021;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">10.</td>
          <td class="padding-top-0">
            Surat Keputusan Kepala Dinas Tenaga Kerja Kabupaten Buleleng Nomor
            50 Tahun 2023 tentang Pengesahan Peraturan Tata Tertib Kerja 2023 -
            2025 Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng.
          </td>
        </tr> -->
        <tr>
          <td
            colspan="4"
            class="text-align-center"
            style="letter-spacing: 0.3em"
          >
            MEMUTUSKAN
          </td>
        </tr>

        <tr>
          <td>Menetapkan</td>
          <td>:</td>
        </tr>
        <tr>
          <td>Pertama</td>
          <td>:</td>
          <td colspan="2" v-if="jenisDokumen.includes('kp')">
            Pegawai Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng yang
            namanya tercantum dalam keputusan ini :
          </td>
          <td colspan="2" v-if="jenisDokumen === 'kgb'">
            Dengan dipenuhinya masa kerja dan syarat-syarat kenaikan gaji
            berkala kepada :
          </td>
          <td colspan="2" v-if="jenisDokumen === 'persen80'">
            Pekerja Kontrak Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng
            yang tersebut dibawah ini :
          </td>
          <td colspan="2" v-if="jenisDokumen === 'persen100'">
            Calon Pegawai Tetap Perusahaan Umum Daerah Air Minum Hita Buleleng
            yang namanya tercantum dalam keputusan ini :
          </td>
        </tr>
        <tr>
          <td colspan="2"></td>
          <td colspan="2">
            <table class="table-details">
              <tr>
                <td style="width: 3%">1.</td>
                <td style="width: 38%">Nama</td>
                <td style="width: 3%">:</td>
                <td>{{ pegawais[0].nama }}</td>
              </tr>
              <tr>
                <td style="width: 3%">2.</td>
                <td style="width: 38%">Tempat/Tgl Lahir</td>
                <td style="width: 3%">:</td>
                <td>
                  {{ pegawais[0].tempat_lahir }},
                  {{
                    commonFunction.formatDateIndonesia(pegawais[0].tgl_lahir)
                  }}
                </td>
              </tr>
              <tr>
                <td style="width: 3%">3.</td>
                <td style="width: 38%">NIK</td>
                <td style="width: 3%">:</td>
                <td>{{ pegawais[0].nik }}</td>
              </tr>
              <tr>
                <td style="width: 3%">4.</td>
                <td style="width: 38%">Pendidikan</td>
                <td style="width: 3%">:</td>
                <td v-if="response">{{ response.pendidikan }}</td>
              </tr>
              <tr>
                <td style="width: 3%">5.</td>
                <td style="width: 38%">Tanggal Mulai Kerja</td>
                <td style="width: 3%">:</td>
                <td>
                  {{
                    commonFunction.formatDateIndonesia(
                      pegawais[0].tgl_mulai_bekerja,
                    )
                  }}
                </td>
              </tr>
              <tr v-if="!jenisDokumen.includes('persen')">
                <td style="width: 3%">6.</td>
                <td style="width: 38%">Tanggal Pengangkatan</td>
                <td style="width: 3%">:</td>
                <td>
                  {{
                    commonFunction.formatDateIndonesia(pegawais[0].tgl_diangkat)
                  }}
                </td>
              </tr>
              <tr>
                <td style="width: 3%">
                  {{ jenisDokumen.includes("persen") ? "6." : "7." }}
                </td>
                <td style="width: 38%">Pendidikan Penyesuaian</td>
                <td style="width: 3%">:</td>
                <!-- <td >{{ pendidikanPenyesuaian }}</td> -->
                <td v-if="response">
                  {{ response?.pendidikanPenyesuaian ?? "-" }}
                </td>
              </tr>
              <tr>
                <td style="width: 3%">
                  {{ jenisDokumen.includes("persen") ? "7." : "8." }}
                </td>
                <td style="width: 38%">Tanggal Penyesuaian</td>
                <td style="width: 3%">:</td>
                <td v-if="response">
                  {{
                    response.pendidikanPenyesuaianTgl
                      ? commonFunction.formatDateIndonesia(
                          response.pendidikanPenyesuaianTgl,
                        )
                      : "-"
                  }}
                </td>
              </tr>
              <tr>
                <td colspan="4" class="padding-top-10">
                  atas dasar Surat Keputusan terakhir gaji/pangkat yang
                  ditetapkan :
                </td>
              </tr>
              <tr class="padding-top-10">
                <td style="width: 3%" class="padding-top-10">a.</td>
                <td style="width: 38%" class="padding-top-10">Oleh pejabat</td>
                <td style="width: 3%" class="padding-top-10">:</td>
                <td class="padding-top-10">
                  Direksi Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng
                </td>
              </tr>
              <tr>
                <td style="width: 3%">b.</td>
                <td style="width: 38%">Tanggal</td>
                <td style="width: 3%">:</td>
                <td v-if="response">
                  {{
                    commonFunction.formatDateIndonesia(response.tglSkTerakhir)
                  }}
                </td>
              </tr>
              <tr>
                <td style="width: 3%">c.</td>
                <td style="width: 38%">Nomor</td>
                <td style="width: 3%">:</td>
                <td v-if="response">{{ response.noSkTerakhir }}</td>
              </tr>
              <tr>
                <td style="width: 3%">d.</td>
                <td style="width: 38%">Pangkat/Golongan</td>
                <td style="width: 3%">:</td>
                <td v-if="response">
                  {{
                    jenisDokumen === "persen100"
                      ? response.golTerakhir.replace(/\(/, " Masa Percobaan (")
                      : response.golTerakhir
                  }}
                </td>
              </tr>
              <tr v-if="!jenisDokumen.includes('persen')">
                <td style="width: 3%">e.</td>
                <td style="width: 38%">
                  Masa kerja golongan pada tanggal tersebut
                </td>
                <td style="width: 3%">:</td>
                <td v-if="response">
                  {{ response.mkTahunTerakhir }} Tahun
                  {{ response.mkBulanTerakhir }} Bulan
                </td>
              </tr>
              <tr v-if="!jenisDokumen.includes('persen')">
                <td style="width: 3%">f.</td>
                <td style="width: 38%">Gaji pokok</td>
                <td style="width: 3%">:</td>
                <td v-if="response">
                  Rp.
                  {{
                    commonFunction.formatNumberToCurrency(
                      response.gapokTerakhir,
                    )
                  }},- ({{
                    commonFunction.formatNumberTerbilang(
                      response.gapokTerakhir,
                    )
                  }})
                </td>
              </tr>
              <tr>
                <td style="width: 3%">
                  {{ jenisDokumen.includes("persen") ? "e." : "g." }}
                </td>
                <td style="width: 38%">Tgl. mulai berlaku</td>
                <td style="width: 3%">:</td>
                <td v-if="response">
                  {{
                    commonFunction.formatDateIndonesia(
                      response.tglBerlakuTerakhir,
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td colspan="4" class="padding-top-10" v-if="jenisDokumen">
                  <!-- Diberikan -->
                  <!-- {{
                    jenisDokumen.includes("persen") ? "menjadi " : "Diberikan "
                  }} -->

                  {{
                    jenisDokumen === "persen80"
                      ? "menjadi "
                      : jenisDokumen === "persen100"
                      ? "diangkat menjadi "
                      : "Diberikan "
                  }}

                  <span class="text-bold">
                    {{
                      jenisDokumen.includes("persen")
                        ? titleText.replace("Pengangkatan", "").trim()
                        : titleText
                    }}
                  </span>

                  {{ jenisDokumen === "persen100" ? "(PKWTT)" : "" }}
                  {{
                    jenisDokumen.includes("persen")
                      ? "dengan: "
                      : "sehingga memperoleh:"
                  }}
                </td>
              </tr>
              <template
                v-if="jenisDokumen === 'kpReguler' || jenisDokumen === 'kgb'"
              >
                <tr class="padding-top-10">
                  <td style="width: 3%" class="padding-top-10">a.</td>
                  <td style="width: 38%" class="padding-top-10">
                    Gaji pokok baru
                  </td>
                  <td style="width: 3%" class="padding-top-10">:</td>
                  <td class="padding-top-10" v-if="response">
                    Rp.
                    {{
                      commonFunction.formatNumberToCurrency(
                        response.gapokTerbaru,
                      )
                    }},- ({{
                      commonFunction.formatNumberTerbilang(
                        response.gapokTerbaru,
                      )
                    }})
                  </td>
                </tr>
                <tr>
                  <td style="width: 3%">b.</td>
                  <td style="width: 38%">Berdasarkan masa kerja</td>
                  <td style="width: 3%">:</td>
                  <td v-if="response">
                    {{ response.mkTahunTerbaru }} Tahun
                    {{ response.mkBulanTerbaru }} Bulan
                  </td>
                </tr>
                <tr>
                  <td style="width: 3%">c.</td>
                  <td style="width: 38%">Dalam golongan</td>
                  <td style="width: 3%">:</td>
                  <td v-if="response">{{ response.golTerbaru }}</td>
                </tr>
                <tr>
                  <td style="width: 3%">d.</td>
                  <td style="width: 38%">Berkedudukan sebagai</td>
                  <td style="width: 3%">:</td>
                  <td>{{ pegawais[0].jabatan_print }}</td>
                </tr>
              </template>

              <template
                v-if="
                  jenisDokumen === 'kpPilihan' ||
                  jenisDokumen === 'kpPenyesuaian' ||
                  jenisDokumen.includes('persen')
                "
              >
                <tr class="padding-top-10">
                  <td style="width: 3%" class="padding-top-10">a.</td>
                  <td style="width: 38%" class="padding-top-10">
                    Pangkat/Golongan
                  </td>
                  <td style="width: 3%" class="padding-top-10">:</td>
                  <td v-if="response" class="padding-top-10">
                    <!-- {{ response.golTerbaru }} -->
                    {{
                      jenisDokumen === "persen80"
                        ? response.golTerbaru.replace(/\(/, " Masa Percobaan (")
                        : response.golTerbaru
                    }}
                  </td>
                </tr>

                <tr>
                  <td style="width: 3%">b.</td>
                  <td style="width: 38%">Berdasarkan masa kerja</td>
                  <td style="width: 3%">:</td>
                  <td v-if="response">
                    {{ response.mkTahunTerbaru }} Tahun
                    {{ response.mkBulanTerbaru }} Bulan
                  </td>
                </tr>

                <tr>
                  <td style="width: 3%">c.</td>
                  <td style="width: 38%">Gaji pokok baru</td>
                  <td style="width: 3%">:</td>
                  <td v-if="response && jenisDokumen !== 'persen80'">
                    Rp.
                    {{
                      commonFunction.formatNumberToCurrency(
                        response.gapokTerbaru,
                      )
                    }},- ({{
                      commonFunction.formatNumberTerbilang(
                        response.gapokTerbaru,
                      )
                    }})
                  </td>
                  <td v-if="response && jenisDokumen === 'persen80'">
                    Rp.
                    {{
                      commonFunction.formatNumberToCurrency(
                        response.gapokTerbaru,
                      )
                    }},- x 80% = Rp.
                    {{
                      commonFunction.formatNumberToCurrency(
                        response.gapokTerbaru80Persen,
                      )
                    }},- ({{
                      commonFunction.formatNumberTerbilang(
                        response.gapokTerbaru80Persen,
                      )
                    }})
                  </td>
                </tr>

                <tr>
                  <td style="width: 3%">d.</td>
                  <td style="width: 38%">Berkedudukan sebagai</td>
                  <td style="width: 3%">:</td>
                  <td>{{ pegawais[0].jabatan_print }}</td>
                </tr>
              </template>
            </table>
          </td>
        </tr>
        <tr>
          <td>Kedua</td>
          <td>:</td>
          <td colspan="2" v-if="response">
            Keputusan ini mulai berlaku pada tanggal
            <span class="text-bold">{{
              commonFunction.formatDateIndonesia(response.tglBerlakuTerbaru)
            }}</span>
          </td>
        </tr>
      </table>
      <table style="border-collapse: collapse">
        <tr>
          <td style="width: 50%"></td>
          <td>Ditetapkan di</td>
          <td style="width: 5%">:</td>
          <td>Singaraja</td>
        </tr>
        <tr>
          <td style="width: 50%"></td>
          <td>pada tanggal</td>
          <td style="width: 5%">:</td>
          <td>
            {{
              commonFunction.formatDateIndonesia(
                commonFunction.getCurrentDate(),
              )
            }}
          </td>
        </tr>
        <tr>
          <td style="width: 50%"></td>
          <td colspan="4" class="text-align-center">
            Perusahaan Umum Daerah Air Minum<br />
            Tirta Hita Buleleng
          </td>
        </tr>
        <tr>
          <td style="width: 50%"></td>
          <td
            colspan="4"
            class="text-align-center"
            style="padding-top: 100"
            v-if="
              jenisDokumen.includes('kp') || jenisDokumen.includes('persen')
            "
          >
            <br />
            <br />
            <br />
            <div class="text-underline" v-if="response">
              <strong>{{ response.dirut }}</strong>
            </div>
            Direktur Utama
          </td>
          <td
            colspan="4"
            class="text-align-center"
            style="padding-top: 100"
            v-if="jenisDokumen.includes('kgb')"
          >
            <br />
            <br />
            <br />
            <div class="text-underline" v-if="response">
              <strong>{{ response.dirum }}</strong>
            </div>
            Direktur Umum
          </td>
        </tr>
      </table>
    </div>
  </div>
  <!-- <button @click="">Download Dokumen</button> -->
  <DxButton
    @click="Export2Word('exportContent')"
    text="Download Dokumen"
    type="default"
    :icon="'download'"
    styling-mode="filled"
  />
</template>

<style scoped lang="scss">
.table-details,
.table-details td,
.table-details tr {
  padding: 2;
  border: none; /* optional, if you want to remove borders as well */
}

.custom-list {
  list-style-position: inside; /* Moves number alignment inside the text */
  padding-left: 0;
  margin: 0;
  margin-left: 0;
}
.custom-list li {
  padding-left: 0;
  margin-left: 0;
}

.text-align-center {
  text-align: center !important;
}
.text-align-left {
  text-align: left;
}

.text-underline {
  text-decoration: underline;
}
.padding-top-0 {
  padding-top: 0 !important;
  line-height: 1 !important;
}

.padding-bottom-0 {
  padding-bottom: 0 !important;
  line-height: 1 !important;
}

.padding-top-10 {
  padding-top: 10 !important;
}

.padding-bottom-2 {
  padding-bottom: 2 !important;
}

.text-align-top {
  vertical-align: top;
}
.font-size-13 {
  font-size: 13px;
}
.general-style {
  font-family: "Times New Roman", Times, serif;
  color: black;
  line-height: 1.5;
}

.text-bold {
  font-weight: bold;
}

table {
  border: none;
  width: 100%;
  border-collapse: collapse;
}
td,
th {
  border: none;
  padding: 8px;
  vertical-align: top;
}
</style>

<script>
import { BASE_URL } from "@/global-constants";
import * as commonFunction from "@/utils/common-function.js";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import { DxButton } from "devextreme-vue/button";
export default {
  components: { DxButton },
  setup() {
    return { commonFunction };
  },
  props: {
    pegawais: {
      type: Array,
      required: true,
    },
    info: {
      type: String,
      required: true,
    },
    noSurat: {
      type: String,
      required: true,
    },
    tglSurat: {
      type: String,
      required: true,
    },
    jenisDokumen: {
      type: String,
      required: true,
    },
  },

  data() {
    {
      return {
        // kopPerumdaPath: require("@/assets/kop_perumda.png"),
        kopUrl: `${BASE_URL}/files/kop_perumda.png`,
        pendidikan: null,
        pendidikanPenyesuaian: null,
        pendidikanPenyesuaianTgl: null,
        kpTerakhir: null,
        kgbTerakhir: null,
        response: null,
      };
    }
  },

  computed: {
    titleText() {
      const titles = {
        kpReguler: "Kenaikan Pangkat Reguler",
        kpPenyesuaian: "Kenaikan Pangkat Penyesuaian",
        kpPilihan: "Kenaikan Pangkat Pilihan",
        kgb: "Kenaikan Gaji Berkala",
        persen80: "Pengangkatan Calon Pegawai Tetap",
        persen100: "Pengangkatan Pegawai Tetap",
      };
      return titles[this.jenisDokumen] || "";
    },
  },
  async created() {
    console.log(" hello created", this.pegawais);
    this.getData();
  },

  methods: {
    async getData() {
      const res = await axios.get(`${API_BASE_URL}/surat`, {
        params: {
          template: this.jenisDokumen,
          pegawais: this.pegawais,
        },
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "Content-Type": "application/json",
        },
      });
      this.response = res.data;
      console.log("getData response", this.response);
    },
    Export2Word(element, filename = "") {
      console.log("Export2Word pegawaiIds", this.pegawaiIds);
      // Get element content
      const content = document.getElementById(element).innerHTML;

      // Inline styles or include external CSS links

      const styles = `
        <style>
        .text-underline {
  text-decoration: underline;
}
       .table-details,
.table-details td,
.table-details tr {
  padding: 2;
  border: none; /* optional, if you want to remove borders as well */
}

.custom-list {
  list-style-position: inside; /* Moves number alignment inside the text */
  padding-left: 0;
  margin: 0;
  margin-left: 0;
}
.custom-list li {
  padding-left: 0;
  margin-left: 0;
}

.text-align-center {
  text-align: center !important;
}
.text-align-left {
  text-align: left;
}

.padding-top-0 {
  padding-top: 0 !important;
  line-height: 1 !important;
}

.padding-bottom-0 {
  padding-bottom: 0 !important;
  line-height: 1 !important;
}

.padding-top-10 {
  padding-top: 10 !important;
}

.padding-bottom-2 {
  padding-bottom: 2 !important;
}

.text-align-top {
  vertical-align: top;
}
.font-size-13 {
  font-size: 13px;
}
.general-style {
  font-family: "Times New Roman", Times, serif;
  color: black;
  line-height: 1.5;
}

.text-bold {
  font-weight: bold;
}

table {
  border: none;
  width: 100%;
  border-collapse: collapse;
}
td,
th {
  border: none;
  padding: 8px;
  vertical-align: top;
}
        </style>
      `;

      const preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
        "xmlns:w='urn:schemas-microsoft-com:office:word' " +
        "xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'>" +
        "<title>Export HTML To Doc</title>" +
        styles +
        "</head><body>";

      const postHtml = "</body></html>";
      const html = preHtml + content + postHtml;

      const blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // File URL creation
      const url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // File naming
      filename = filename
        ? filename + ".doc"
        : this.titleText +
          " - " +
          this.pegawais[0].nik +
          " - " + // <-- Remove the extra +
          this.pegawais[0].nama +
          ".doc";

      // Create download link
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
  },
};
</script>
